import type { Shape } from './en';
import type { signatureDe } from './signature.de';

export const signatureEn: Shape<typeof signatureDe> = {
  title: 'Signature',
  description: 'For reports and protocols: documents insert the signature with name and job title.',
  current: 'Stored signature',
  none: 'No signature stored yet.',
  unused:
    'Signatures require the permission to create documents. The stored signature can be deleted.',
  preview: 'Stored signature',
  add: 'Add signature',
  change: 'Change signature',
  delete: 'Delete signature',
  deleteTitle: 'Delete signature?',
  deleteDescription: 'Image and job title will be deleted.',
  deleted: 'Signature deleted',
  saved: 'Signature saved',
  role: 'Job title',
  roleHint: 'Appears below the signature, e.g. “Fire safety officer”.',
  roleSaved: 'Job title saved',
  dialog: {
    title: 'Add signature',
    description: 'Sign in the area with finger, pen or mouse, or upload an image of the signature.',
    pad: 'Area to sign in',
    clear: 'Start over',
    upload: 'Upload image',
    uploadHint: 'PNG, JPEG or WebP up to 10 MB. A white background becomes transparent.',
    uploaded: 'Signature from the uploaded image',
    draw: 'Draw instead',
    missing: 'Sign in the area or upload an image.',
    save: 'Save',
  },
  upload: {
    type: 'Only images in PNG, JPEG or WebP format.',
    size: 'The image is larger than 10 MB.',
    decode: 'The image cannot be read. Choose a different one.',
    empty: 'No signature can be found in the image. Dark writing on white paper works best.',
  },
  errors: {
    format: 'The image is not a valid PNG.',
    size: 'The image is larger than 500 KB.',
    dimensions: 'The image is larger than 2000 × 1000 pixels.',
    forbidden:
      'A signature can only be stored with the permission to create documents, and only in your own company.',
  },
};
